import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOperatorsStart,
  fetchWeeklyChosenOperatorStart,
} from '../../../redux/operators/operators.actions';
import ApiLoader from '../../ApiLoader';
import OperatorItem from '../OperatorItem';
import useTranslation from 'hooks/useTranslation';

const mapState = (state) => ({
  operators: state.operatorsData.operators,
  weeklyChosenOperator: state.operatorsData.weeklyChosenOperator,
});

const OperatorList = (props) => {
  const { operators, weeklyChosenOperator } = useSelector(mapState);
  const dispatch = useDispatch();
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  useEffect(() => {
    if (!operators.loading && !operators.data) {
      dispatch(fetchOperatorsStart());
    }
    dispatch(fetchWeeklyChosenOperatorStart());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {Object.keys(weeklyChosenOperator).length > 0 && (
        <div className='operators__list__title'>
          <h2>{t('OPERATORS_LSIT')}</h2>
        </div>
      )}
      {operators.loading && !operators.data && <ApiLoader />}
      {!operators.loading && operators.data && operators.data.length > 0 && (
        <div className='operators__list__inner grid'>
          {operators.data
            .filter((operator) => operator.id !== weeklyChosenOperator.id)
            .map((filteredOperator) => (
              <OperatorItem key={filteredOperator.id} {...filteredOperator} />
            ))}
        </div>
      )}
    </>
  );
};

export default OperatorList;
